// extracted by mini-css-extract-plugin
export default {"erButton":"QuestionButtons-module__erButton___ZDhvZ mr-2"};